import React, { useEffect } from "react";
import { Navigate } from "react-router";

import { SEARCH_KEY } from "fond/constants";
import { Navigation } from "fond/projects/Navigation";
import { updateFilter } from "fond/projects/redux";
import StarredContent from "fond/projects/StarredContent";
import { useAppDispatch, useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

/**
 * A top level component used for displaying starred projects.
 */
const Starred: React.FC = () => {
  const dispatch = useAppDispatch();

  // Clear filter
  useEffect(() => {
    dispatch(updateFilter(null));
  }, [dispatch]);

  // Backwards-compat redirect for old /starred?search=term URLs
  const searchQuery = useQueryParams(SEARCH_KEY);
  if (searchQuery) {
    return <Navigate to={`/search?${SEARCH_KEY}=${encodeURIComponent(searchQuery)}&scope=workspace`} replace />;
  }

  return <PageContent title="Starred" mainContent={<StarredContent />} navigation={<Navigation />} testId="filter-starred" />;
};

export default Starred;
